"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconReset_1 = __importDefault(require("../../../assets/icons/IconReset"));
const images_1 = require("../../../assets/images");
const IconLike_1 = __importDefault(require("../../../components/Icon/IconLike"));
const IconRetweet_1 = __importDefault(require("../../../components/Icon/IconRetweet"));
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const ModalConfirm_1 = __importDefault(require("../../../components/modal/ModalConfirm"));
const ModalReportReason_1 = __importDefault(require("../../../components/modal/ModalReportReason"));
const ModalReportSuccess_1 = __importDefault(require("../../../components/modal/ModalReportSuccess"));
const ModalShare_1 = __importDefault(require("../../../components/modal/ModalShare"));
const ModalSubMyPost_1 = __importDefault(require("../../../components/modal/ModalSubMyPost"));
const ModalSuccess_1 = __importDefault(require("../../../components/modal/ModalSuccess"));
const Status_1 = require("../../../components/status/Status");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const tooltips_1 = require("../../../components/tooltips");
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const ListImage_1 = __importDefault(require("./ListImage"));
const QuoteTweet_1 = __importDefault(require("./QuoteTweet"));
const NUMBER_OF_LINE_CONTENT = 20;
const ItemUser = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { data, idTweet, firestorePath = 'tweets', count, displayTweet, disableShowMore } = props;
    const [dataTweet, setDataTweet] = (0, react_1.useState)(data);
    const [dataquoteTweetPath, setDataquoteTweetPath] = (0, react_1.useState)('');
    const [pathQuote, setPathQuote] = (0, react_1.useState)('');
    const [idQuote, setIdQuote] = (0, react_1.useState)('');
    const [pathFirebase, setPathFirebase] = (0, react_1.useState)(firestorePath || 'tweets');
    const [idPost, setIdPost] = (0, react_1.useState)(idTweet);
    const firebaseUser = (0, react_redux_1.useSelector)((state) => state.loginFirebaseReducer.user);
    const refDataCollected = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (data?.type != 2) {
            setDataTweet(data);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (firebaseUser && !refDataCollected.current) {
            refDataCollected.current = true;
            if (data?.type == 2) {
                if (react_native_1.Platform.OS === 'web') {
                    const { firebase } = require('../../../../web/firebase/config');
                    const path = data?.repostTweetPath;
                    let containsRelai = path?.indexOf('replies') != -1;
                    let parts = '';
                    let textAfterSlash = null;
                    let textpath = null;
                    if (containsRelai) {
                        textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                        textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
                    }
                    else {
                        parts = path.split('/');
                        textAfterSlash = parts[1];
                    }
                    setPathFirebase(textpath ? textpath : firestorePath);
                    // setIdPost(textAfterSlash)
                    firebase
                        .firestore()
                        .collection(textpath ? textpath : firestorePath)
                        .doc(textAfterSlash)
                        .onSnapshot((snapshot) => {
                        let dataRetweet = snapshot.data();
                        dataRetweet.tweetId = snapshot.id;
                        setIdPost(textAfterSlash);
                        setDataTweet(dataRetweet);
                        if (dataRetweet.type == 3) {
                            const path = dataRetweet?.quoteTweetPath;
                            let containsReplies = path?.indexOf('replies') != -1;
                            let parts = '';
                            let textAfterSlash = null;
                            let textpath = null;
                            if (containsReplies) {
                                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
                            }
                            else {
                                parts = path.split('/');
                                textAfterSlash = parts[1];
                            }
                            setIdQuote(textAfterSlash);
                            setPathQuote(textpath || firestorePath);
                            if (react_native_1.Platform.OS === 'web') {
                                const { firebase } = require('../../../../web/firebase/config');
                                firebase
                                    .firestore()
                                    .collection(textpath ? textpath : firestorePath)
                                    .doc(textAfterSlash)
                                    .get()
                                    .then((res) => {
                                    setDataquoteTweetPath(res.data());
                                })
                                    .catch((_err) => { });
                            }
                        }
                    });
                }
            }
            if (data.type == 3) {
                const path = data?.quoteTweetPath;
                let containsReplies = path?.indexOf('replies') != -1;
                let parts = '';
                let textAfterSlash = null;
                let textpath = null;
                if (containsReplies) {
                    textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                    textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
                }
                else {
                    parts = path.split('/');
                    textAfterSlash = parts[1];
                }
                setIdQuote(textAfterSlash);
                setPathQuote(textpath || firestorePath);
                if (react_native_1.Platform.OS === 'web') {
                    const { firebase } = require('../../../../web/firebase/config');
                    firebase
                        .firestore()
                        .collection(textpath ? textpath : firestorePath)
                        .doc(textAfterSlash)
                        .get()
                        .then((res) => {
                        setDataquoteTweetPath(res.data());
                    })
                        .catch((_err) => { });
                }
            }
        }
    }, [firebaseUser]);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [visiblePeport, setVisiblePeport] = (0, react_1.useState)(false);
    const [isAlert, setIsAlert] = (0, react_1.useState)(false);
    const [visibleMyPost, setVisibleMyPost] = (0, react_1.useState)(false);
    const [visibleConfirm, setVisibleConfirm] = (0, react_1.useState)(false);
    const [visibleModalSuccess, setVisibleModalSuccess] = (0, react_1.useState)(false);
    const [visibleModal, setVisibleModal] = (0, react_1.useState)(false);
    const [showMore, setShowMore] = (0, react_1.useState)(true);
    const [numberlineContent, setNumberlineContent] = (0, react_1.useState)(0);
    const [checkShowContentBlock, setCheckShowContentBlock] = (0, react_1.useState)(false);
    const handleShowMore = () => {
        setShowMore(true);
    };
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const deletePost = () => {
        setVisibleConfirm(true);
    };
    const dataListFollow = (0, react_redux_1.useSelector)((state) => state?.listFollowReducer?.listFollow, react_redux_1.shallowEqual);
    const dataListBlock = (0, react_redux_1.useSelector)((state) => state?.listBlockReducer?.listBlock, react_redux_1.shallowEqual);
    const checkBlock = dataListBlock.some((item) => item == data?.userId);
    const dataListMute = (0, react_redux_1.useSelector)((state) => state?.listMuteReducer?.listMute, react_redux_1.shallowEqual);
    const checkMute = dataListMute.some((item) => item == data?.userId);
    const checkDataReTweet = () => {
        let idFollow = dataListFollow.some((item) => item == dataTweet?.userId);
        let idBlock = dataListBlock.some((item) => item == dataTweet?.userId);
        let idMute = dataListMute.some((item) => item == dataTweet?.userId);
        if (data?.type == 2 && dataTweet?.isDeleted == 1) {
            return '投稿者によって削除された投稿です';
        }
        else if (dataTweet?.publicationRange == 1 &&
            !idFollow &&
            data?.type == 2 &&
            dataTweet?.userId != dataUser?.user_id) {
            return `フォロワー限定の投稿です。\nフォローして投稿を見てみましょう。`;
        }
        else if (data?.type == 2 && idBlock) {
            return `あなたがブロックしたユーザーの投稿です`;
        }
        else if (data?.type == 2 && idMute) {
            return `あなたがミュートしたユーザーの投稿です`;
        }
        return false;
    };
    const navigateToUserProfile = () => {
        // if (checkShowContentBlock){
        // 	return false
        // }
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: dataTweet.userHandle,
            },
        });
    };
    const ViewCheckReplais = () => {
        const path = data?.path;
        let containsRelai = path?.indexOf('replies') == -1;
        if (containsRelai) {
            return false;
        }
        else {
            if (data?.isDeleted == 1) {
                return (react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        borderBottomWidth: 1,
                        borderBottomColor: '#DDDDDD',
                    } },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.ViewBlockReplai, onPress: () => {
                            (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                postId: (0, helpler_1.urlPost)(`${pathFirebase}/${dataTweet._id || dataTweet?.tweetId}`),
                            });
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(14),
                                lineHeight: (0, scale_1.moderateScale)(21),
                                color: '#292A33',
                                maxWidth: (0, scale_1.scale)(220),
                            } }, "\u3059\u3067\u306B\u524A\u9664\u3055\u308C\u305F\u30B3\u30E1\u30F3\u30C8\u3067\u3059"))));
            }
            else if (checkBlock || checkMute) {
                return (react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        borderBottomWidth: 1,
                        borderBottomColor: '#DDDDDD',
                    } },
                    react_1.default.createElement(react_native_1.View, { style: styles.ViewBlockReplai },
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(14),
                                lineHeight: (0, scale_1.moderateScale)(21),
                                color: '#292A33',
                                maxWidth: (0, scale_1.scale)(220),
                            } }, checkBlock
                            ? 'ブロックしているユーザによる投稿です。'
                            : 'ミュートしているユーザによる投稿です。'),
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setCheckShowContentBlock(true) },
                            react_1.default.createElement(CustomText_1.default, { weight: '600', style: {
                                    fontSize: (0, scale_1.moderateScale)(14),
                                    lineHeight: (0, scale_1.moderateScale)(21),
                                    color: '#292A33',
                                } }, "\u8868\u793A")))));
            }
            else {
                return false;
            }
        }
    };
    if (data?.type == 1
        &&
            dataTweet?.publicationRange == 1
        &&
            dataUser?.user_id != dataTweet.userId
        &&
            !dataListFollow.includes(`${dataTweet.userId}`)) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (data?.isDeleted == 1 || checkBlock || checkMute) && !checkShowContentBlock ? (ViewCheckReplais()) : (react_1.default.createElement(react_native_1.View, { style: styles.container },
        data?.type == 2 && (react_1.default.createElement(react_native_1.View, { style: {
                flexDirection: 'row',
                marginBottom: (0, scale_1.scale)(8),
                marginLeft: (0, scale_1.scale)(4),
            } },
            react_1.default.createElement(IconReset_1.default, { color: "#545454" }),
            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textReTweet, weight: "300" }, `${data?.nickname ? data?.nickname : constants_1.DEFAULT_NAME}さんが引用しました`))),
        react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
            react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(52) } },
                react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                    react_1.default.createElement(react_native_1.Image, { source: dataTweet?.thumbnailUrl
                            ? { uri: dataTweet?.thumbnailUrl }
                            : images_1.images.AvatarDefaul, style: {
                            height: (0, scale_1.scale)(40),
                            width: (0, scale_1.scale)(40),
                            borderRadius: (0, scale_1.scale)(20),
                        } }))),
            react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(290) } },
                react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                    react_1.default.createElement(react_native_1.View, { style: styles.View },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    zIndex: 99,
                                    alignItems: 'center',
                                } },
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textName, weight: "600", onPress: navigateToUserProfile }, dataTweet?.nickname || constants_1.DEFAULT_NAME),
                                react_1.default.createElement(react_native_1.View, { style: { marginLeft: (0, scale_1.scale)(12) } },
                                    react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(dataTweet?.createdAt).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.stringToDateFormat)(dataTweet?.createdAt)} ${dataTweet?.isEdited ? '(編集済み)' : ''}`))),
                            react_1.default.createElement(react_native_1.View, { style: styles.View },
                                react_1.default.createElement(CustomText_1.default, { style: styles.textTagName, weight: "300" }, `@${dataTweet?.userHandle || dataTweet?.user_handle}`))),
                        react_1.default.createElement(react_native_1.TouchableOpacity, null,
                            react_1.default.createElement(IconThreeDoc_1.default, { data: dataTweet, uri: pathFirebase == 'tweets'
                                    ? `${window.location.origin}/post?postId=${dataTweet?.tweetId || dataTweet?._id}`
                                    : `${window.location.origin}/post?postId=${(0, helpler_1.urlPost)(`${pathFirebase}/${dataTweet?.tweetId || dataTweet?._id}`)}`, displayTweet: (data) => {
                                    displayTweet(data);
                                }, firestorePath: pathFirebase, disabled: ViewCheckReplais() != false })))),
                checkDataReTweet() ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                            if (firestorePath != 'tweets') {
                                return (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                    postId: (0, helpler_1.urlPost)(`${pathFirebase}/${dataTweet._id || dataTweet?.tweetId}`),
                                });
                            }
                            (0, rootNavigation_1.navigate)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                postId: (0, helpler_1.urlPost)(`${pathFirebase}/${dataTweet._id || dataTweet?.tweetId}`),
                            });
                        }, disabled: checkDataReTweet() != false || checkShowContentBlock },
                        react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(12) } },
                            react_1.default.createElement(Status_1.Status, { statusPost: dataTweet?.publicationRange }),
                            react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                                    color: '#06c',
                                    textDecorationLine: 'underline',
                                } },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(15),
                                        lineHeight: (0, scale_1.moderateScale)(23),
                                        color: '#292A33',
                                        marginTop: (0, scale_1.scale)(8),
                                    }, numberOfLines: (!disableShowMore && !showMore) ? NUMBER_OF_LINE_CONTENT : undefined, onLayout: (event) => {
                                        if (disableShowMore)
                                            return;
                                        let numberline = event.nativeEvent.layout.height /
                                            (0, scale_1.moderateScale)(23);
                                        if (numberline >= NUMBER_OF_LINE_CONTENT + 1 &&
                                            numberlineContent < NUMBER_OF_LINE_CONTENT) {
                                            setShowMore(false);
                                            setNumberlineContent(numberline);
                                        }
                                    } }, dataTweet?.content &&
                                    dataTweet?.content
                                        .split(helpler_1.hashtagRegex)
                                        .map((string, index) => {
                                        if (string.match(helpler_1.hashtagRegex)) {
                                            return (react_1.default.createElement(react_native_1.Text, { key: index, style: {
                                                    color: '#007AFF',
                                                }, onPress: () => {
                                                    // Xử lý sự kiện khi nhấn vào hashtag
                                                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                                        screen: Routes_1.default.HASHTAG_DETAIL,
                                                        params: {
                                                            hashtag: string?.slice(1),
                                                            typeScreen: 0,
                                                            typeHashTag: 3,
                                                        },
                                                    });
                                                } }, string));
                                        }
                                        else {
                                            return (react_1.default.createElement(react_native_1.Text, { key: index }, string));
                                        }
                                    }))),
                            !showMore && numberlineContent > 5 && (react_1.default.createElement(CustomText_1.default, { onPress: handleShowMore, weight: "300", style: {
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                    color: '#007AFF',
                                } }, "\u7D9A\u304D\u3092\u898B\u308B")),
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    maxWidth: (0, scale_1.scale)(343),
                                    flexWrap: 'wrap',
                                    marginBottom: (0, scale_1.scale)(8),
                                } }),
                            react_1.default.createElement(ListImage_1.default, { data: dataTweet?.images, type: "post" }),
                            dataTweet?.type == 3 && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                                    if (pathQuote != 'tweets') {
                                        return (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                            postId: (0, helpler_1.urlPost)(`${pathQuote}/${idQuote}`),
                                        });
                                    }
                                    (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                        postId: idQuote,
                                    });
                                }, style: { marginTop: (0, scale_1.scale)(8) } },
                                react_1.default.createElement(QuoteTweet_1.default, { data: dataquoteTweetPath }))))),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginTop: (0, scale_1.scale)(12) } },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                                if (dataUser?.registration_status == 0) {
                                    return dispatch(slice_1.default.actions.showRequestLoginModal());
                                }
                                (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT, {
                                    data: (0, helpler_1.urlPost)(`${pathFirebase}/${dataTweet._id || dataTweet?.tweetId}`),
                                    type: 'POST',
                                });
                            }, disabled: checkShowContentBlock },
                            react_1.default.createElement(IconComment_1.default, { color: '#545454' }),
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                    color: '#545454',
                                    marginLeft: (0, scale_1.scale)(8),
                                    marginRight: (0, scale_1.scale)(24),
                                } }, dataTweet?.numOfReplies || 0)),
                        react_1.default.createElement(IconRetweet_1.default, { idPost: idPost, dataTweet: dataTweet, data: data, displayTweet: (data) => {
                                displayTweet(data);
                            }, disabled: checkShowContentBlock }),
                        react_1.default.createElement(IconLike_1.default, { numberLikes: +dataTweet?.likes, idPost: idPost, disabled: checkShowContentBlock, data: dataTweet })))))),
        checkDataReTweet() && (react_1.default.createElement(react_native_1.View, { style: {
                width: (0, scale_1.scale)(342),
                height: (0, scale_1.scale)(45),
                borderWidth: 1,
                borderColor: '#DDDDDD',
                borderRadius: 3,
                backgroundColor: '#EEEEEE',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: (0, scale_1.scale)(12),
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(14),
                    lineHeight: (0, scale_1.moderateScale)(21),
                    color: '#292A33',
                    width: (0, scale_1.scale)(294),
                } }, checkDataReTweet()))),
        react_1.default.createElement(ModalReportReason_1.default, { visible: visiblePeport, onClose: () => setVisiblePeport(false), onNext: () => {
                setVisiblePeport(false);
                setIsAlert(true);
            } }),
        react_1.default.createElement(ModalReportSuccess_1.default, { visible: isAlert, onClose: () => {
                setIsAlert(false);
            }, title: "\u3054\u5831\u544A\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059", textFirst: "\u5F53\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u5B89\u5168\u3068\u5FEB\u9069\u6027\u3092\u4FDD\u3064\u305F\u3081\u306B\u3054\u5354\u529B\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002", textSecond: "\u79C1\u305F\u3061\u306E\u30C1\u30FC\u30E0\u304C\u901A\u5831\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3001\u5FC5\u8981\u306A\u5BFE\u5FDC\u3092\u884C\u3044\u307E\u3059\u3002", textThirs: "\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306B\u306F\u6570\u65E5\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7406\u89E3\u304F\u3060\u3055\u3044\u3002", textFour: "\u901A\u5831\u306B\u95A2\u3057\u3066\u3055\u3089\u306A\u308B\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u304C\u5FC5\u8981\u306A\u5834\u5408\u3001\u307E\u305F\u306F\u72B6\u6CC1\u304C\u5909\u5316\u3057\u305F\u5834\u5408\u306F\u3001\u3044\u3064\u3067\u3082\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002", textFive: "" }),
        react_1.default.createElement(ModalSubMyPost_1.default, { visible: visibleMyPost, onClose: () => {
                setVisibleMyPost(false);
            }, modalPosition: modalPosition, displayTweet: (data) => {
                displayTweet(data);
            }, deletePost: () => {
                setVisibleMyPost(false), deletePost();
            } }),
        react_1.default.createElement(ModalConfirm_1.default, { visible: visibleConfirm, onClose: () => {
                setVisibleConfirm(false);
            }, title: "\u30B3\u30E1\u30F3\u30C8\u3092\u524A\u9664\u3057\u307E\u3059\u304B?", content: "\u524A\u9664\u3057\u305F\u30B3\u30E1\u30F3\u30C8\u306F\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002", onConfirm: () => {
                setVisibleModalSuccess(true), setVisibleConfirm(false);
                setTimeout(() => {
                    setVisibleModalSuccess(false);
                }, 1500);
            } }),
        react_1.default.createElement(ModalSuccess_1.default, { content: "\u524A\u9664\u3057\u305F\u30B3\u30E1\u30F3\u30C8\u306F\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002", visible: visibleModalSuccess, onClose: () => setVisibleModalSuccess(false) }),
        react_1.default.createElement(ModalShare_1.default, { visible: visibleModal, onClose: () => setVisibleModal(false) })))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        paddingVertical: (0, scale_1.scale)(12),
        width: '100%',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingTop: (0, scale_1.scale)(12),
        borderBottomWidth: 1,
        borderColor: '#DDDDDD',
    },
    textReTweet: {
        color: '#7C7C7C',
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        maxWidth: (0, scale_1.scale)(240),
        marginLeft: (0, scale_1.scale)(8),
    },
    textName: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        maxWidth: (0, scale_1.scale)(200),
    },
    textTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(15),
        color: '#7C7C7C',
        marginLeft: (0, scale_1.scale)(12),
        // marginTop: scale(2),
    },
    View: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textTagName: {
        maxWidth: (0, scale_1.scale)(240),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(15),
        marginTop: (0, scale_1.scale)(5),
        color: '#888888',
    },
    textTimeNow: {
        fontSize: (0, scale_1.moderateScale)(9),
        lineHeight: (0, scale_1.moderateScale)(14),
        color: '#FEFEFE',
        backgroundColor: '#000000B2',
        paddingHorizontal: (0, scale_1.scale)(2),
        top: (0, scale_1.scale)(25),
        position: 'absolute',
        zIndex: 99,
        borderRadius: (0, scale_1.scale)(2),
        textAlign: 'center',
        left: 0,
        maxWidth: 200,
    },
    viewQuoteTweet: {
        width: (0, scale_1.scale)(295),
        borderWidth: 1,
        borderColor: '#DDDDDD',
        borderRadius: (0, scale_1.scale)(5),
        paddingHorizontal: (0, scale_1.scale)(12),
        paddingVertical: (0, scale_1.scale)(12),
        marginTop: (0, scale_1.scale)(8),
    },
    ViewBlockReplai: {
        width: (0, scale_1.scale)(343),
        paddingHorizontal: (0, scale_1.scale)(24),
        paddingVertical: (0, scale_1.scale)(12),
        backgroundColor: '#EDEDED',
        borderWidth: 1,
        borderColor: '#DDDDDD',
        borderRadius: 3,
        justifyContent: 'space-between',
        marginHorizontal: (0, scale_1.scale)(16),
        marginTop: (0, scale_1.scale)(12),
        marginBottom: (0, scale_1.scale)(12),
        flexDirection: 'row',
        alignItems: 'center',
    },
});
exports.default = ItemUser;
